import { stateName } from './constants';

const localState = state => state[stateName];

export const getCountryId = state => localState(state).settings.countryId;
export const getCityId = state => localState(state).settings.cityId;
export const getCityTitle = state => localState(state).settings.cityTitle;
export const getIsCityVisible = state => localState(state).settings.isCityVisible;
export const getUserAbout = state => localState(state).settings.about;
export const getProfileSettings = state => localState(state).settings;
export const getSettingsUiState = state => localState(state).uiState;
export const getError = state => localState(state).error;
export const getLanguageCode = state => localState(state).settings.languageCode;
export const getUsername = state => localState(state).settings.username;
export const getContactEmail = state => localState(state).settings.contactEmail;
export const getContactNumber = state => localState(state).settings.contactNumber;
export const getVat = state => localState(state).settings.vat;